/**
 * Which Staff page actions this user can really complete (pure, unit-tested). Saving an edit and deleting an
 * employee write the staff records, and the database rules (firestore.rules) let only write_staff or
 * import_staff through - so the page's own edit_staff / delete_staff is needed AND one of those. Before, a role
 * holding only edit_staff / delete_staff saw the buttons and every save or delete was refused (audit ADM-02).
 * This mirrors the rules, it does not change who may write.
 */
import { PERMISSIONS } from '../../constants/permissions';

export const staffActionsFor = (hasPermission) => {
    const can = (p) => !!hasPermission(p);
    const write = can(PERMISSIONS.write_staff) || can(PERMISSIONS.import_staff);
    return {
        edit: write && can(PERMISSIONS.edit_staff),
        remove: write && can(PERMISSIONS.delete_staff)
    };
};
